import { motion } from "framer-motion";

const CHAPTERS = [
  {
    number: "01",
    title: "The No-Forklift Dilemma, Solved",
    body: "Most commercial suites, retail boutiques, and job sites have no loading dock and no forklift. Freight stalls at the curb. We bridge that gap — the truck arrives with the muscle built in.",
    testid: "chapter-card-01",
  },
  {
    number: "02",
    title: "3,000 LB of Hydraulic Power",
    body: "Our 26-foot box truck carries a heavy-duty hydraulic lift gate that lowers machinery, pallets, and oversized cargo gently to ground level — no dock, no forklift, no problem.",
    testid: "chapter-card-02",
  },
  {
    number: "03",
    title: "Arizona-Native Reliability",
    body: "Dispatched straight out of Phoenix — 4539 N 22nd St. We know the Valley's arteries and the state's long haul routes, from Maricopa County to the far corners of Arizona.",
    testid: "chapter-card-03",
  },
];

export const Manifesto = () => (
  <section id="manifesto" data-testid="manifesto-section" className="relative py-28 sm:py-36">
    <div className="max-w-7xl mx-auto px-6 lg:px-10">
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
        className="mb-16 sm:mb-24"
      >
        <p className="font-mono text-xs tracking-[0.3em] uppercase text-[#C85A32] mb-5 flex items-center gap-3">
          <span className="w-10 h-px bg-[#C85A32]" />
          02 // The Lift-Gate Advantage
        </p>
        <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-semibold tracking-tight text-[#F7F2EB] max-w-3xl leading-tight">
          Heavy freight doesn't wait for a loading dock. <span className="italic text-[#E89D4B]">Neither do we.</span>
        </h2>
      </motion.div>

      <div>
        {CHAPTERS.map((ch, i) => (
          <motion.article
            key={ch.number}
            data-testid={ch.testid}
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.8, delay: i * 0.12, ease: [0.16, 1, 0.3, 1] }}
            className="group grid grid-cols-1 md:grid-cols-[160px_1fr_1.4fr] gap-6 md:gap-10 items-baseline border-t border-[#C85A32]/20 py-12 sm:py-14 last:border-b"
          >
            <span className="font-display text-6xl sm:text-7xl font-bold text-transparent [-webkit-text-stroke:1px_#C85A32] transition-all duration-500 group-hover:[-webkit-text-stroke:1px_#E89D4B]">
              {ch.number}
            </span>
            <h3 className="font-display text-2xl sm:text-3xl font-semibold text-[#F7F2EB] leading-snug">
              {ch.title}
            </h3>
            <p className="text-base text-[#E6DACB]/85 leading-relaxed">{ch.body}</p>
          </motion.article>
        ))}
      </div>
    </div>
  </section>
);
